import EntityInspector from './EntityInspector';
export default class GlowInspector extends EntityInspector {
  sunLongitude = 0;
  sunLatitude = 0;
  constructor(parentGui, instance, glow) {
    super(parentGui, instance, glow, {
      boundingBoxColor: false,
      boundingBoxes: false,
      opacity: true,
      visibility: true
    });
    this.addColorController(glow, 'color').name('Color').onChange(v => {
      glow.color = v;
      this.notify(glow);
    });
  }
}